export const trimMessage = (message: string): string => {
  return message.trim();
};
